import { RefObjetFacture } from './ref-objet-facture.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { RefQuantiteFacture } from './ref-quantite-facture.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { QuantiteInfos } from './quantite-infos.models';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class ObjetFactureTriOperateur {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idsToSend: { key: 'idsToSend', converter: new (ArrayClassConverterFactory.build(Number))() },
        idObjet: { key: 'idObjet', converter: new (ArrayClassConverterFactory.build(Number))() },
        fonctionnelsId: { key: 'fonctionnelId', converter: new (ArrayClassConverterFactory.build(String))() },
        idOperateur: { key: 'idOperateur' },
        raisonSocialeOperateur: { key: 'raisonSocialeOperateur' },
        cahier: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))() },
        annee: { key: 'annee' },
        quantite: { key: 'quantite', converter: new (ArrayClassConverterFactory.build(Number))() },
        refQuantiteFacture: { key: 'idRefQuantiteFacture', converter: new (DataIdConverterFactory.build(RefObjetFacture, 'refQuantiteFactureList'))() },
        estFacture: { key: 'estFacture', optional: true },
        checked: { key: 'checked', optional: true },
        quantiteInfos: { key: 'quantiteInfos', converter: new (ArrayClassConverterFactory.build(QuantiteInfos))() },
        quantiteInfosOperateurGroupe: { key: 'quantiteInfosOperateurGroupe', converter: new (ArrayClassConverterFactory.build(QuantiteInfos))() }
    };

    id: number;
    idsToSend: number[];
    idsObjet: number[];
    fonctionnelsId: string[];
    idOperateur: number;
    raisonSocialeOperateur: string;
    cahier: Cahier;
    annee: number;
    quantite: number[];
    refQuantiteFacture: RefQuantiteFacture[];
    estFacture: boolean;
    checked?: boolean;
    quantiteInfos: QuantiteInfos[];
    quantiteInfosOperateurGroupe: QuantiteInfos[];
}
